export default "__VITE_ASSET__DKDh5HOR__"